import { createListenerMiddleware } from '@reduxjs/toolkit';
import { constant, createListenerEffect, normalizeAccountRole } from '@socialive/common';
import { setAccountInfo } from '~/store/accountInfo';
import { setAuthToken } from '~/store/env';

export const effect = createListenerEffect(
  'setAccountInfo<Listener>',
  async (payload, { dispatch, unsubscribe, trigger }) => {
    unsubscribe();

    const accountId = sessionStorage.getItem('currentAccountId') ?? localStorage.getItem('currentAccountId');
    const accountsData = sessionStorage.getItem('accounts') ?? localStorage.getItem('accounts');
    const userId = sessionStorage.getItem('userId') ?? localStorage.getItem('userId');
    const userName = sessionStorage.getItem('userName') ?? localStorage.getItem('userName');
    const email = sessionStorage.getItem('globalUserName') ?? localStorage.getItem('globalUserName');
    const rawRole = sessionStorage.getItem('currentAccountRole') ?? localStorage.getItem('currentAccountRole');
    const accounts = accountsData ? JSON.parse(accountsData) : [];
    const authToken = sessionStorage.getItem('authToken') ?? localStorage.getItem('authToken');

    const role = normalizeAccountRole(rawRole);

    await dispatch(setAuthToken({ authToken, trigger }));

    await dispatch(
      setAccountInfo({
        accountId,
        accounts,
        userId,
        role,
        userName,
        email,
        trigger,
      })
    );
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  matcher: constant(true),
  effect,
});

export default middleware;
